import { render, staticRenderFns } from "./WsExamGroupsListItemDetails.vue?vue&type=template&id=30636563"
import script from "./WsExamGroupsListItemDetails.vue?vue&type=script&lang=js"
export * from "./WsExamGroupsListItemDetails.vue?vue&type=script&lang=js"
import style0 from "./WsExamGroupsListItemDetails.vue?vue&type=style&index=0&id=30636563&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports